import "./App.css";
import { InputField } from "./components/inputfield";
import { FormulaWeight } from "./components/formulaweight";
import { ElementTable } from "./components/elementtable";
import { SContainer } from "./components/styled";

function App() {
  return (
    <SContainer>
      <InputField></InputField>
      <FormulaWeight></FormulaWeight>
      <ElementTable></ElementTable>
    </SContainer>
  );
}

export default App;
